// src/components/PulsingSquareLoader.tsx
import React from 'react';
import './PulsingSquareLoader.css';

const PulsingSquareLoader: React.FC<{ size?: number }> = ({ size = 32 }) => {
  // The style prop is used here for simplicity to pass the dynamic size.
  // In a larger application, consider using CSS variables or a more robust styling solution if this becomes common.
  return <div className="pulsing-square-loader" style={{ width: size, height: size }}></div>;
};

export default PulsingSquareLoader;